import { DialogConfig } from 'src/api/types';

export const defineMessageFirstBlobResponsesAmount = (dataResourse: DialogConfig | undefined, messageId: string) => {
  const messageData = dataResourse?.script[messageId];
  const FALLBACK_MESSAGES_AMOUNT = 2;

  if (messageData) {
    return messageData.quickResponses.length >= 3 ? 3 : messageData.quickResponses.length;
  }

  return FALLBACK_MESSAGES_AMOUNT;
};
